import React, { useState } from 'react';
import axios from 'axios';
import { API_URL } from '../config';
import './BugReportModal.css';

interface BugReportModalProps {
  isOpen: boolean;
  onClose: () => void;
  sessionId: string;
  chapterNumber?: number;
}

const BugReportModal: React.FC<BugReportModalProps> = ({
  isOpen,
  onClose,
  sessionId,
  chapterNumber,
}) => {
  const [description, setDescription] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  if (!isOpen) return null;

  const handleSubmit = async () => {
    if (!description.trim()) return;
    setIsSubmitting(true);
    try {
      await axios.post(`${API_URL}/feedback/bug-report/`, {
        session_id: sessionId,
        chapter_number: chapterNumber ?? null,
        description: description.trim(),
      });
      setSubmitted(true);
    } catch (error) {
      console.error('Error submitting bug report:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    setDescription('');
    setSubmitted(false);
    onClose();
  };

  return (
    <div className="bug-report-overlay" onClick={handleClose}>
      <div className="bug-report-modal" onClick={(e) => e.stopPropagation()}>
        {submitted ? (
          <div className="bug-report-thanks">
            <p>Thanks for letting us know!</p>
            <button className="bug-report-close-btn" onClick={handleClose}>Close</button>
          </div>
        ) : (
          <>
            <h3 className="bug-report-title">What went wrong?</h3>
            <textarea
              className="bug-report-textarea"
              placeholder="Describe the problem..."
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              maxLength={2000}
              rows={5}
              autoFocus
            />
            <div className="bug-report-actions">
              <button className="bug-report-cancel" onClick={handleClose}>Cancel</button>
              <button
                className="bug-report-submit"
                onClick={handleSubmit}
                disabled={!description.trim() || isSubmitting}
              >
                {isSubmitting ? 'Sending...' : 'Send'}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default BugReportModal;
